import { NO_LOCALE_PATHS } from '../routes/server'
import { DEFAULT_LOCALE } from './i18n'

/**
 * Check if a path matches any of the no-locale paths
 */
function isNoLocalePath(path: string): boolean {
  // Normalize path to start with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  return NO_LOCALE_PATHS.some(
    (noLocalePath) =>
      normalizedPath === noLocalePath ||
      normalizedPath.startsWith(`${noLocalePath}/`)
  )
}

function shouldSkipLocalePrefixing(path: string): boolean {
  if (
    // Skip external URLs (including protocol-relative URLs)
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('//') ||
    // Skip anchors, mailto, tel
    path.startsWith('#') ||
    path.startsWith('/#') ||
    path.startsWith('mailto:') ||
    path.startsWith('tel:') ||
    // Skip specific flaggedPages pages (no i18n)
    isNoLocalePath(path)
  ) {
    return true
  }
  return false
}

/**
 * Build a URL with optional locale prefix.
 * Handles all URL types: external URLs, anchors, mailto/tel links, webflow pages, etc.
 * Safe to call on any href - will return the path unchanged if locale shouldn't be added.
 */
export function getUrl(params: { locale?: string; path: string }): string {
  const { path } = params

  // Return path unchanged for URLs that shouldn't have locale prefix
  if (shouldSkipLocalePrefixing(path)) {
    return path
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  const locale =
    params.locale === DEFAULT_LOCALE ? null : params.locale?.split('-')[0]

  if (!locale) {
    return normalizedPath
  }

  return `/${locale}${normalizedPath}`
}
